
<template>
    <div>
        <!-- <template v-if="loading"> -->
        <div class="wrap"
             v-if="questions.length">
            <div class="exercises"
                 v-for="(data,index) in questions"
                 v-show="data.asks.length">
                <!-- 小学 -->
                <span class="question_num">第{{index+1}}题</span>
                <div v-if='sid == 21'>
                    <div class="quest_title clearfix"
                         v-if="data.subject.content||data.subject.image">
                        <span v-if="data.subject.content!=''"
                              v-html='data.subject.content'></span>
                        <img :src="data.subject.image"
                             v-if="data.subject.image!=''">
                    </div>
                    <div v-for="(ask,inx) in data.asks">
                        <!-- 选择题 -->
                        <div class="judge-box choose"
                             v-if="ask.display_type==1">
                            <!-- <div class="judgeicon" :class="[ask.is_right == '1'? 'dui' : 'cuo']"></div> -->
                            <div class="judgeicon"
                                 :class="[ask.user_result == '1'? 'dui' : 'cuo']"></div>
                            <choice :question='ask'
                                    :number='ask.title'
                                    :sid="sid"
                                    :askLength='data.asks.length'
                                    :type="0"></choice>
                        </div>
                        <!-- 填空 -->
                        <div class="judge-box"
                             v-if='ask.display_type == 2'>
                            <div class="judgeicon"
                                 :class="[ask.user_result == '1'? 'dui' : 'cuo']"></div>
                            <blanks :question='ask'
                                    :myColor='true'
                                    :number='ask.title'
                                    :checked="true"
                                    :askLength='data.asks.length'></blanks>
                        </div>
                        <!-- 主观题 -->
                        <div class="judge-box"
                             v-if='ask.display_type == 3'>
                            <div class="judgeicon"
                                 :class="[ask.user_result == '1'? 'dui' : 'cuo']"></div>
                            <subjective :ask='data.asks'
                                        :myColor='true'
                                        :index='inx'
                                        :checked="true"
                                        :question='ask'
                                        :askLength='data.asks.length'></subjective>
                        </div>
                        <!-- 连线题 -->
                        <div class="judge-box line"
                             v-if="ask.display_type==4">
                            <div class="judgeicon"
                                 :class="[ask.user_result == '1'? 'dui' : 'cuo']"></div>
                            <lines :wrongType="false"
                                   :ask='ask'
                                   :sheet="ask.user_answer"
                                   :result="ask.user_result"
                                   :onlyshow='true'
                                   :myColor='true'
                                   :askLength='data.asks.length'></lines>
                        </div>

                        <div class="answer-wrap"
                             v-if="ask.display_type==4||ask.display_type==2||(ask.display_type==1&&ask.options.length>1)">
                            <div class="user"
                                 :class="[ask.display_type == '4'?'block':'']">
                                <div class="user-he">【正确答案】</div>
                                <div class="user-answer line"
                                     v-if="ask.display_type==4">
                                    <!-- <line :ask='ask' :sheet="a.right_answer" :result="a.is_right" :onlyshow='true' :tag='1'></line> -->
                                    <lines :ask='ask'
                                           :sheet="ask.right_answer"
                                           :onlyshow='true'
                                           :askLength='data.asks.length'
                                           :number='data.number'
                                           :checked='true'
                                           :onlyanswer='true'
                                           :tag='1'></lines>
                                </div>
                                <div class="user-answer"
                                     v-else-if="ask.display_type==2">
                                    <template v-for="(a,ai) in ask.right_answer">
                                        <span v-html="$options.filters.strReplace(a,'\#\#','或')"
                                              v-if="!ai"></span>
                                        <span v-html="'，'+$options.filters.strReplace(a,'\#\#','或')"
                                              v-else></span>
                                    </template>
                                </div>
                                <!-- 正确答案 gsd -->
                                <div class="user-answer"
                                     v-else>{{ask.right_option.option}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 初中 -->
                <div v-else>
                    <div class="quest_title clearfix"
                         v-if="data.content.content||data.content.image_url">
                        <span v-if="data.content.content"
                              v-html="data.content.content"></span>
                        <img :src="data.content.image_url"
                             v-if="data.content.image_url" />
                    </div>
                    <div v-for="(ask,inx) in data.asks">
                        <!-- 选择题 -->
                        <div class="judge-box choose"
                             v-if="data.display==1||data.display==3">
                            <div class="judgeicon"
                                 :class="[ask.is_right == '1'? 'dui' : 'cuo']"></div>
                            <choice :question='ask'
                                    :askLength='data.asks.length'
                                    :sid="sid"
                                    :type="0"></choice>
                        </div>
                        <div class="answer-wrap">
                            <div class="user"
                                 :class="[ask.display == '4'?'block':'']">
                                <div class="user-he">【正确答案】</div>
                                <div class="user-answer">{{ask.right_option.option}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <noResouse :text="'没有作业数据'"
                   v-else></noResouse>
        <!-- </template> -->
        <!-- <template v-else>
      <loadingS></loadingS>
    </template> -->
    </div>
</template>

<script type="text/ecmascript-6">
//   import headers from 'SRC/components/base/header.vue'
// import loadingS from 'COMPONENTS/common/loading.vue';
import noResouse from 'COMPONENTS/noResouse.vue';
import choice from './module/choice.vue'  //选择题
import blanks from './module/blanks.vue'  //填空题
import lines from './module/line.vue';     //连线题
import subjective from './module/subjective.vue';//主观题
export default {
    props: ['questions', 'sid'],
    data () {
        return {

        }
    },
    computed: {

    },
    mounted () {
        this.$nextTick(function () {
            MathJax.Hub.Typeset(document.body)
        })
    },
    methods: {
    },
    async created () {

    },
    components: {
        // loadingS,
        noResouse,
        subjective,
        choice,
        blanks,
        lines,
        //   moreLoading
    },
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
@import "./src/assets/scss/common/_mixin";

[v-cloak] {
    display: none;
}

#classdetailstu {
    min-height: 100vh;
}

.wrap {
    padding-bottom: 96px / $ppr;
    &.noBottom {
        padding-bottom: 0;
    }
}
//   .header {
//     background: #5e89ef;
//     .left {
//       display: block;
//       width: 18px/$ppr;
//       height: 34px/$ppr;
//       background: url("../img/choose_back.png") 0 0 no-repeat;
//       background-size: 100% 100%;
//     }
//   }

.tip {
    height: 96px / $ppr;
    line-height: 96px / $ppr;
    font-size: 30px / $ppr;
    background-color: #fff;
    padding: 0 24px / $ppr;
    margin-bottom: 24px / $ppr;
    span {
        color: #ff6600;
    }
}
.select_wrapper {
    padding: 12px / $ppr 24px / $ppr;
    background-color: #fff;
    margin-bottom: 24px / $ppr;
    select {
        width: 240px / $ppr;
        height: 70px / $ppr;
        border-radius: 8px / $ppr;
        border-color: #dcdcdc;
        padding-left: 32px / $ppr;
        font-size: 30px / $ppr;
    }
}
.bottom_btn {
    position: fixed;
    left: 0;
    bottom: 0;
    height: 96px / $ppr;
    width: 100%;
    z-index: 8;
    div {
        position: absolute;
        bottom: 0;
        right: 0;
        left: 0;
        background: #5e89ef;
        text-align: center;
        font-size: 30px / $ppr;
        color: #fff;
        line-height: 96px / $ppr;
    }
}

.answer-wrap {
    // padding: 30px/$ppr 24px/$ppr;
    background-color: #fff;
    margin-bottom: 24px / $ppr;
    min-height: 96px / $ppr;
    box-sizing: border-box;
    .user {
        color: #222;
        font-size: 30px / $ppr;
        line-height: 48px / $ppr;
        font-size: 28px / $ppr;
        .user-he {
        }
        .user-answer {
        }
    }
}

.quest_title {
    padding: 24px / $ppr 0;
    line-height: 46px / $ppr;
    font-size: 30px / $ppr;
    color: #333;
    // border-bottom: 1px/$ppr solid #E8E8E8;
    background: #fff;
    display: flex;
    display: -moz-flex;
    display: -webkit-flex;
    display: -webkit-flex;
    .tit_num {
        width: 48px / $ppr;
    }
    div {
        flex: 1;
        -moz-box-flex: 1;
        -webkit-box-flex: 1;
        -webkit-flex: 1;
        -ms-flex: 1;
    }
}
.quest_title > span {
    float: left;
}
.quest_con {
    position: relative;
}

.nowork {
    color: #aaa;
    text-align: center;
    margin-top: 304px / $ppr;
}

.judge-box {
    position: relative;
    font-size: 28px / $ppr;
}

.judgeicon {
    position: absolute;
    right: 24px / $ppr;
    top: -60px / $ppr;
    z-index: 2;

    //background-color: #21BF63;
}

.dui {
    width: 35px / $ppr;
    height: 36px / $ppr;
    background-image: url("img/right.png");
    background-size: cover;
}

.cuo {
    width: 33px / $ppr;
    height: 36px / $ppr;
    background-image: url("img/wrong.png");
    background-size: cover;
}

.exercises {
    background-color: #fff;
    position: relative;
    // margin-bottom:24px/$ppr;
    width: 600px / $ppr;
    padding: 36px / $ppr 30px / $ppr;
    margin: 0 auto;
    background: #fff;
    margin-top: 30px / $ppr;
    border-radius: 16px / $ppr;
}

.block {
    display: block !important;
}

.judge-box /deep/ .title_t > img {
    left: 0;
}
.exercises /deep/ .choose {
    margin-top: 0 !important;
}
.question_num {
    font-size: 28px / $ppr;
    font-weight: bold;
    margin-bottom: -20px / $ppr;
    display: block;
    height: 80px / $ppr;
}
.user-he {
    margin-left: -10px / $ppr;
    font-weight: bold;
    padding-top: 40px / $ppr;
}
</style>
